<div class="container is-fluid">
  <h1 class="title">Lägg till schema</h1>

  <form name="form" (ngSubmit)="onSubmit()" [formGroup]="addScheduleForm">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Switch</label>
          <div class="control">
            <div class="select schedule-select">
              <select formControlName="switch">
                <option value="1">Garage - Höger</option>
                <option value="51">Garage - Vänster</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Datum</label>
          <div class="control">
            <input class="input schedule-date-field" type="date" formControlName="myDate" inputmode="numeric" [min]="minDate" aria-label="Välj datum">
          </div>
        </div>
      </div>
    </div>

    <div class="columns schedule-time-row">
      <div class="column">
        <div class="field">
          <label class="label" for="starttime">Start</label>
          <div class="control">
            <input id="starttime" class="input schedule-time-field" type="time" step="900" formControlName="starttime" aria-label="Starttid">
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label" for="endtime">Slut</label>
          <div class="control">
            <input id="endtime" class="input schedule-time-field" type="time" step="900" formControlName="endtime" aria-label="Sluttid">
          </div>
        </div>
      </div>
    </div>

    <div class="field is-grouped">
      <div class="control">
        <button class="button is-primary" type="submit" [disabled]="!addScheduleForm.valid">Spara schema</button>
      </div>
      <div class="control">
        <button class="button is-text" type="button">Avbryt</button>
      </div>
    </div>
  </form>
</div>
